export default "__VITE_ASSET__CBuj39aB__"